import { useContext } from "react";
import { Navigate } from "react-router-dom";
import UserContext from "../context/UserContext";
import LoadingSpinner from "../components/LoadingSpinner";

const PaymentPlanRoute = ({ children }) => {
  const { user, loading } = useContext(UserContext);

  if (loading) {
    return (
      <LoadingSpinner />
    );
  }

  if (!user) {
    return <Navigate to="/register" replace />;
  }

  if (user && user.isActive === false) {
    return <Navigate to="/resend-email-verification" replace />;
  }

  if (user && user.role_name === 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return user && (user.role_name === "free user" || user.role_name === "subscriber") && user.isActive === true ? (
    children
  ) : (
    <Navigate to="/" replace />
  );
};

export default PaymentPlanRoute;
